import { HttpInterceptorFn, HttpResponse, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { of, tap } from 'rxjs';
import { CacheService } from '../services/cache.service';

export const CACHE_ENABLED = new HttpContextToken<boolean>(() => false);

export const cachingInterceptor: HttpInterceptorFn = (req, next) => {
  // Əgər sorğu GET deyilsə və ya keşləmə aktiv edilməyibsə, növbəti addıma keç
  if (req.method !== 'GET' || !req.context.get(CACHE_ENABLED)) {
    return next(req);
  }

  const cache = inject(CacheService);
  const cachedResponse = cache.get(req.urlWithParams);

  if (cachedResponse) {
    return of(cachedResponse);
  }

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        cache.put(req.urlWithParams, event);
      }
    })
  );
};
